<template>
  <div id="carousel-slider" class="carousel slide carousel-fade" data-ride="carousel" data-interval="false" v-bind:class="$route.name">
      <div class="carousel-preload" v-if="loading">
        <img src="/static/imgs/loading.gif">
      </div>

      <div class="carousel-inner">
        <div class="item active lazy-load item-capa" v-for="capa in filterBy(capas, filter, 'section')" v-bind:style="{ 'background-image': 'url(' + api + capa.img + ')' }" :key="$route.name">
          <div class="item-content" v-bind:class="capa.color">
            <div class="item-content--icon-wrapper">
              <img v-if="capa.color === 'white'" class="item-content--icon" src="static/imgs/icon.svg">
              <img v-if="capa.color === 'black'" class="item-content--icon" src="static/imgs/icon-black.svg">
            </div>
            <h1 class="item-content--title">{{ capa.title }}</h1>
            <h3 v-if="capa.desc" class="item-content--desc">{{ capa.desc }}</h3>
            <h3 v-if="capa.longtext" class="item-content--longtext" v-html="capa.longtext"></h3>
            <h3 v-if="capa.shorttext" class="item-content--shorttext" v-html="capa.shorttext"></h3>
            <div class="item-content--counter"></div>
          </div>
        </div>
        
        <div class="item lazy-load item-slide" v-for="slide in filterBy(slides, filter, 'section')" v-bind:data-src="api + slide.img" :key="$route.name">
          <div class="item-content" v-bind:class="slide.color">
            <div class="item-content--icon-wrapper">
              <img v-if="slide.color === 'white'" class="item-content--icon" src="static/imgs/icon.svg">
              <img v-if="slide.color === 'black'" class="item-content--icon" src="static/imgs/icon-black.svg">
            </div>
            <h1 class="item-content--title">{{ slide.title }}</h1>
            <h3 v-if="slide.desc" class="item-content--desc">{{ slide.desc }}</h3>
            <h3 v-if="slide.longtext" class="item-content--longtext" v-html="slide.longtext"></h3>
            <div v-if="slide.shorttext"  class="item-content--shorttext-wrapper">
              <h3 v-if="slide.shorttext" class="item-content--shorttext" v-html="slide.shorttext"></h3>
            </div>
            <img class="item-content--model" v-if="slide.model" v-bind:src="api + slide.model">
            <div v-if="slide.boxes[0] !== ''" class="item-content--boxes">
              <lightbox class="item-content--box" v-if="slide.boxes" v-for="box in slide.boxes" :key="box" v-bind:src="api + box" v-bind:style="{ 'background-image': 'url(' + api + box + ')' }">
                <img v-if="slide.boxes" width="100px" v-bind:src="api + box">
              </lightbox>
            </div>


            <div class="item-content--counter"></div>
          </div>
        </div>
      </div>

      <a class="carousel-control left" href="#carousel-slider" data-slide="prev">
        <img src="/static/imgs/icons/prev.svg">
      </a>
      <a class="carousel-control right" href="#carousel-slider" data-slide="next">
        <img src="/static/imgs/icons/next.svg">
      </a>
  </div>
</template>

<script>

import axios from 'axios'
import VueAxios from 'vue-axios'

export default {
  name: 'Carousel',
  data: function () {
    return {
      filter: 'intro',
      background: '',
      loading: true,
      slides: [],
      capas: [],
      api: ''
    }
  },
  mounted () {
    this.loadSlides()
    this.loadCapas()
    this.setFilter()
    this.carouselCounter()
    this.carouselLazyLoad()
  },
  methods: {
    loadSlides: function () {
      var app = this
      axios.get(app.api + '/admin/api/slides').then(function (response) {
        var listaSlides = response.data
        for (var i = listaSlides.length - 1; i > 0; i--) {
          var boxesArray = listaSlides[i].boxes
          var newBoxes = boxesArray.split(',')
          listaSlides[i].boxes = newBoxes
        }

        function shuffleArray (array) {
          for (var i = array.length - 1; i > 0; i--) {
            var j = Math.floor(Math.random() * (i + 1))
            var temp = array[i]
            array[i] = array[j]
            array[j] = temp
          }
          return array
        }
        var randomSlides = shuffleArray(listaSlides)
        app.slides = randomSlides
        app.completeLoading()
      })
    },
    loadCapas: function () {
      var app = this
      axios.get(app.api + '/admin/api/capas').then(function (response) {
        app.capas = response.data
      })
    },
    setFilter: function () {
      $('#carousel-slider').css('opacity', 0.3)
      $('#carousel-slider').carousel(0).addClass(this.$route.params.filter)
      if (this.$route.name !== 'intro') {
        this.filter = this.$route.params.filter
      } else {
        this.filter = 'intro'
      }
      $('#carousel-slider').animate({opacity: 1}, 1000)

      setTimeout(function () {
        var nextSlide = $('.item-slide:nth-child(2)')
        var lastSlide = $('.item-slide:last-child')
        var nextSrc = nextSlide.data('src')
        var lastSrc = lastSlide.data('src')
        nextSlide.css('backgroundImage', 'url(' + nextSrc + ')')
        lastSlide.css('backgroundImage', 'url(' + lastSrc + ')')
      }, 1500)
    },
    carouselCounter: function () {
      $('#carousel-slider').on('slid.bs.carousel', function () {
        var totalItems = $('#carousel-slider .item').length - 1
        var currentIndex = $('div.active').index()
        if (totalItems > 0) {
          $('.item-content--counter').html('' + currentIndex + '/' + totalItems + '')
        }
      })
    },
    carouselLazyLoad: function () {
      $('#carousel-slider').on('slid.bs.carousel', function (e) {
        var $activeItem = $('.active.item', this)
        var $nextImage = null
        if (e.direction === 'left') {
          $nextImage = $activeItem.next('.item-slide')
        } else {
          if ($activeItem.index() === 0) {
            $nextImage = $('.item-slide:last', $activeItem.parent())
          } else {
            $nextImage = $activeItem.prev('.item-slide')
          }
        }
        var src = $nextImage.data('src')
        if (typeof src !== 'undefined' && src !== '') {
          $nextImage.css('backgroundImage', 'url(' + src + ')')
        }
      })
    },
    completeLoading: function () {
      this.loading = false
    }
  },
  watch: {
    // call again the method if the route changes
    '$route': function () {
      this.setFilter()
      this.carouselCounter()
      this.carouselLazyLoad()
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">


</style>



// WEBPACK FOOTER //
// Carousel.vue?1fc5f454